import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';
import NumberFormat from 'react-number-format';

import useStyles from '../BaseInput/useStyles';

const customInput = props => {
  return <TextField {...props} />;
};

const PhoneInput = props => {
  const { label, id, field } = props;
  const classes = useStyles();
  return (
    <NumberFormat
      key={id}
      label={label}
      className={classes.field}
      format="+1 (###) ###-####"
      customInput={customInput}
      variant="outlined"
      id={id}
      type="text"
      InputProps={{
        style: {
          height: '40px',
        },
      }}
      InputLabelProps={{
        shrink: false,
      }}
      {...field}
    />
  );
};

PhoneInput.propTypes = {
  label: PropTypes.string,
};

PhoneInput.defaultProps = {
  label: '',
};

export default PhoneInput;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/Profile/components/ProfileForm/components/PhoneInput/PhoneInput.js